import Image from '../components/common/Image';
import { Mail, MapPin } from 'lucide-react';
export default function Contact() {
    return (<main className='min-h-screen bg-white'>
      {/* Hero Section */}
      <section className='relative h-screen overflow-hidden'>
        <div className='absolute inset-0'>
          <Image src='/images/contact/contact-hero.webp' alt='お問い合わせ' className='w-full h-full object-cover' priority/>
          <div className='absolute inset-0 bg-gradient-to-b from-navy/40 via-navy/30 to-navy/60'/>
        </div>

        <div className='relative z-10 h-full flex flex-col justify-center px-6 md:px-12 lg:px-24'>
          <h1 className='text-7xl md:text-8xl text-white font-bebas tracking-wider'>
            CONTACT
          </h1>
          <p className='mt-6 text-xl md:text-2xl text-white font-noto'>
            お問い合わせ
          </p>
        </div>
      </section>

      <section className='py-24'>
        <div className='container mx-auto px-6'>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 items-start'>
            {/* Contact Information */}
            <div>
              <h2 className='text-3xl font-noto font-bold text-navy mb-8'>
                会社情報
              </h2>

              <div className='space-y-8'>
                <div className='flex items-start gap-4'>
                  <div className='w-12 h-12 rounded-full bg-skyblue/10 flex items-center justify-center flex-shrink-0'>
                    <MapPin className='w-6 h-6 text-skyblue'/>
                  </div>
                  <div>
                    <h3 className='text-lg font-medium text-navy mb-2'>
                      所在地
                    </h3>
                    <p className='text-navy/70'>
                      〒020-0839
                      <br />
                      岩手県盛岡市津志田南3-13-15
                    </p>
                  </div>
                </div>

                <div className='flex items-start gap-4'>
                  <div className='w-12 h-12 rounded-full bg-skyblue/10 flex items-center justify-center flex-shrink-0'>
                    <Mail className='w-6 h-6 text-skyblue'/>
                  </div>
                  <div>
                    <h3 className='text-lg font-medium text-navy mb-2'>
                      メールアドレス
                    </h3>
                    <p className='text-navy/70'>
                      <a href='mailto:info@moriden-setubi.com' className='hover:text-skyblue transition-colors'>
                        info@moriden-setubi.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className='mt-12 p-6 bg-lightgray rounded-lg'>
                <h3 className='text-lg font-medium text-navy mb-4'>
                  お問い合わせについて
                </h3>
                <ul className='space-y-2 text-navy/70'>
                  <li>• 内容確認後、担当者より折り返しご連絡いたします</li>
                  <li>• 営業時間外のお問い合わせは翌営業日の対応となります</li>
                </ul>
              </div>
            </div>

            {/* Map */}
            <div>
              <h2 className='text-3xl font-noto font-bold text-navy mb-8'>
                アクセス
              </h2>
              <div className='rounded-lg overflow-hidden shadow-sm border border-gray-200'>
                <iframe title='盛電設備工業 所在地' src='https://maps.google.com/maps?q=%E5%B2%A9%E6%89%8B%E7%9C%8C%E7%9B%9B%E5%B2%A1%E5%B8%82%E6%B4%A5%E5%BF%97%E7%94%B0%E5%8D%973-13-15&t=m&z=15&output=embed&iwloc=near' width='100%' height='480' style={{ border: 0 }} allowFullScreen loading='lazy' referrerPolicy='no-referrer-when-downgrade'/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>);
}
